import App from './App.vue'
import router from './router'
import { createApp } from 'vue'
import json from '../package.json'

import '@/assets/css/app.css'
import '@/assets/scss/app.scss'

import '@/extensions'

const isDevelopment = process.env.NODE_ENV === "development";

const app = createApp(App);

app.use(router);

app.mount("#app");

export const version = json.version;
export const root = app._container as HTMLElement;
export const backendLink = isDevelopment ? "http://85.215.151.136:1111/api" : "/api";